import React, { PureComponent } from 'react';

import { get } from 'lodash-es';
import { connect } from 'react-redux';

import { Repository } from 'src/components/types';
import { RouteComponentProps } from 'src/router/types';
import { withRouter } from 'src/router/utils';
import { getCurrentRepository } from 'src/selectors/repository-selectors';
import { getTargetUserKey } from 'src/selectors/user-selectors';
import { BucketState } from 'src/types/state';
import { safeDecodePath } from 'src/utils/path';

import { FileViewer } from '../components/file-viewer';

const mapStateToProps = (state: BucketState) => ({
  principalId: getTargetUserKey(state),
  repository: getCurrentRepository(state),
  hash: get(state, 'repository.source.section.hash'),
});

type ConnectFileViewerProps = RouteComponentProps & {
  hash?: string;
  height?: string;
  principalId?: string;
  repository?: Repository;
  viewer?: string;
};

class ConnectFileViewer extends PureComponent<ConnectFileViewerProps> {
  render() {
    const { hash, height, principalId, repository, viewer } = this.props;

    if (!principalId || !repository || !hash) {
      return null;
    }

    const { params } = this.props.match;

    if (!params.path) {
      return null;
    }

    const path = safeDecodePath(params.path || '');
    const [repositoryOwner, repositorySlug] = repository.full_name.split('/');

    return (
      <FileViewer
        height={height}
        principalId={principalId}
        repositoryOwner={repositoryOwner}
        repositorySlug={repositorySlug}
        path={path}
        hash={hash}
        viewer={viewer}
      />
    );
  }
}

export default withRouter(connect(mapStateToProps)(ConnectFileViewer));
